var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.error)?_c('div',{staticClass:"error__message"},[_vm._v(_vm._s(_vm.message))]):_vm._e(),_c('textarea',_vm._g(_vm._b({staticClass:"input",class:_vm.invalid,attrs:{"type":_vm.type,"placeholder":_vm.placeholder,"maxlength":"800"}},'textarea',_vm.$attrs,false),_vm.$listeners))])
}
var staticRenderFns = []

export { render, staticRenderFns }